import Odometer from 'odometer';
import toArray from '@/scripts/utils/get-elements-array';
import ScrollMagic from 'scrollmagic';
import Controller from '@/scripts/utils/scrollmagic/controller';
import selectors from '@/scripts/animation/animation-selectors';
import showWeather from '@/scripts/utils/weather';
import 'odometer/themes/odometer-theme-default.css';
import './counter.scss';

const getAssets = el => ({
  counter: el.querySelector(selectors.counterNumber),
});

document.addEventListener('DOMContentLoaded', () => {
  const counters = toArray('[data-animation*="counter-item"]');
  counters.forEach((wrapper) => {
    const { counter } = getAssets(wrapper);
    const weatherWidget = wrapper.dataset.role === 'weather';
    if (weatherWidget) {
      console.log("Has weather");
      showWeather(document.querySelector('[data-role="weather"]'));
    }
    $(counter).data('value', $(counter).text());


    $(wrapper).addClass('is-loaded');
  });
});



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/counter/counter.js